var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessengerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.0589 27.9411 0 18 0C8.0589 0 0 8.0589 0 18C0 27.9411 8.0589 36 18 36Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1422 24.9304V28.7725L14.7348 26.73C15.7362 27.0187 16.8007 27.1744 17.9037 27.1744C23.8159 27.1744 28.608 22.7025 28.608 17.1868C28.608 11.6708 23.8159 7.19922 17.9037 7.19922C11.9917 7.19922 7.19922 11.6708 7.19922 17.1868C7.19922 20.3102 8.73589 23.0991 11.1422 24.9304Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7612 14.4512L10.9883 20.5634L16.2421 17.6808L18.9871 20.5634L24.7273 14.4512L19.5319 17.2832L16.7612 14.4512Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8.39381,
    y1: 8.65753,
    x2: 8.39381,
    y2: 27.8233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerLogo);
export default __webpack_public_path__ + "static/media/messenger-logo.4a6b10e3cbbac11eaada4ee93ad07ffe.svg";
export { ForwardRef as ReactComponent };